import shallowCompare from '../../helpers/shallowCompare';
import {
  OPTIONS_CANCELLED,
  OPTIONS_ERROR_FROM_REMOTE,
  OPTIONS_GET,
  OPTIONS_SUCCESS,
} from '../actions/options';

// Store options fetched remotely
export const initialState = [];

export default function optionsReducer(state = initialState, action) {
  switch (action.type) {
    case OPTIONS_GET:
      return [
        // We drop the entry of a previous fetch that failed for those same settings,
        // otherwise its error would still be reported once this new one succeeds
        ...state.filter(
          (option) => !option.error || !shallowCompare(option.fetchOptions, action.payload),
        ),
        {
          fetchOptions: action.payload,
          fetchId: action.fetchId,
          pending: true,
          options: null,
          error: false,
        },
      ];
    case OPTIONS_CANCELLED: {
      return state.filter((option) => option.fetchId !== action.fetchId);
    }
    case OPTIONS_SUCCESS: {
      return state.map((optionState) =>
        optionState.fetchId === action.fetchId
          ? {
            ...optionState,
            pending: false,
            options: action.options,
          }
          : optionState,
      );
    }
    case OPTIONS_ERROR_FROM_REMOTE: {
      return state.map((optionState) =>
        optionState.fetchId === action.fetchId
          ? {
            ...optionState,
            pending: false,
            options: [],
            error: true,
          }
          : optionState,
      );
    }
    default:
      return state;
  }
}
